// This file is generated automatically by scripts/generate-icon.js. Don't modify it.

import MapBackground from '../_raw/ui/icon_map_background.svg';
import withIconProps from '../withIconProps';

export default withIconProps(MapBackground, { defaultHeight: 56, defaultWidth: 264 });
